import { ITranslation } from "./types";

export const nl: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Net de winkel uit? Het kan even duren voordat je bon is verwerkt en zichtbaar wordt in het portaal.<br/>In case of any issues, please reach out through venue support.',
    errorReachOutSupportMsg:
      'In case of any issues, please reach out through venue support.',
  },
  api: {
    E_FORCED_LOGOUT: "U bent uitgelogd omdat de connectie is verlopen.",
  },
  orderStatus: {
    draft: "Concept",
    contested: "Betwist",
    paid: "Betaald",
    unpaid: "Onbetaald",
    pending: "In behandeling",
    reviewed: "Beoordeeld",
    paymentProcessing: "Betaling wordt verwerkt",
    refunded: "Teruggegeven",
    unknown: "Onbekend",
  },
  receiptsList: {
    headings: {
      date: "Datum",
      time: "Tijd",
      status: "Status",
      total: "Totaal",
    },
    action: {
      view: "Bekijk",
    },
    statusTooltip: {
      draft: "Concept - Order wordt momenteel gegenereerd door het systeem",
      paid: "Betaald - Order is gegenereerd en betaald",
      paymentProcessing:
        "Betalingsverwerking - Order is gegenereerd en betalingsverwerking gestart",
      unpaid: "Onbetaald - Order is gegenereerd maar betaling is niet gelukt",
      pending:
        "In behandeling - Order is betwist door de klant en is in behandeling bij de retailer",
      reviewed:
        "Reviewed - Order is betwist door de klant en de retailer heeft deze behandeld",
    },
    loadMore: "Meer laden",
    loadingMore: "Laden...",
    showing: "Weergeven",
  },
  receiptDetailScreen: {
    headerTitle: "Kassabon gegevens",
    subtotal: "Subtotaal",
    taxBreakdown: {
      headers: {
        rate: "BTW %",
        netto: "Netto",
        brutto: "Bruto",
        tax: "BTW",
        total: "Totaal:",
      },
    },
    tax: "BTW",
    taxCRV: "CRV",
    total: "Totaal",
    processTime: "Procestijd",
    date: "Datum",
    paymentStatus: "Betaalstatus",
    orderId: "Order ID",
    listOfProducts: "Producten",
  },
  receiptDetailComplain: {
    reportProblem: "Rapporteer een probleem met deze kassabon",
    submitReview: "Stuur voor een review",
    confirmTitle: "Kassabon-melding verstuurd",
    confirmButton: "Klaar",
    addMissingItem: "Voeg missende item toe",
    addMissingItemMessage: "Voeg boodschap toe (optioneel)",
    form: {
      email: {
        label: 'Hoe kunnen we contact met u opnemen?',
        placeholder: 'Uw e-mail, bijv. me@example.com',
        errors: {
          required: 'E-mailadres is verplicht.',
          isEmail: 'Ongeldig e-mailadres.',
          inUse: 'E-mailadres is al in gebruik.'
        }
      }
    }
  },
  receiptsScreen: {
    label: {
      contested: "IN BEHANDELING",
      draft: "CONCEPT",
      empty: "LEEG",
      paid: "BETAALD",
      pending: "DRAFT",
      refunded: "TERUGGESTORT",
      reviewed: "HERZIEN",
      unknown: "ONBEKEND",
      unpaid: "ONBETAALD",
      paymentProcessing: "BETALINGSVERWERKING",
    },
    message: {
      contested: "Betwiste kassabon",
      draft: "Concept kassabon",
      empty: "Lege kassabon",
      paid: "Betaalde kassabon",
      pending: "In bewerking kassabon",
      refunded: "Teruggestorte kassabon",
      reviewed: "Behandelde kassabon",
      unpaid: "Onbetaalde kassabon",
      paymentProcessing: "Betaling wordt verwerkt",
    },
    minutes: "minuten",
    hours: "uren",
    days: "dagen",
  },
  slideModal: {
    close: "Sluit",
    searchPlaceholder: "Zoek item",
  },
  receiptsHome: {
    receiptPortal: "Kassabonnen Portaal",
    selectPaymentType:
      "Selecteer de betaalmethode waarmee u de winkel bent binnengetreden",
    selectPaymentTypeSubtitle: "Als u uw telefoon of smartwatch heeft gebruikt, kies dan Apple Pay of Google Pay",
    cardBin:
      "Eerste %{cardBinDigitsCount} cijfers van een kaartnummer (BIN/IIN)",
    last4: "Geef de laatste 4 cijfers van uw betaalkaart",
    last4Apple: "Geef de laatste 4 cijfers van uw Apple Pay rekeningnummer",
    last4Google: "Geef de laatste 4 cijfers van uw Google Pay rekeningnummer",
    instructionApple:
      "Vind de laatste 4 cijfers van uw Apple Pay-kaartnummer in uw Apple Wallet en voer ze hieronder in",
    openWallet: "Open uw Apple Wallet",
    instructionGoogle:
      "Vind de laatste 4 cijfers van uw Google Pay-kaartnummer in uw Wallet en voer ze hieronder in",
    instructionExternalId:
      "Zoek het betalingsreferentienummer in uw betalingsapp of bankafschrift.",
    externalIdLabel: "Betalingsreferentienummer",
    externalIdPlaceholder: "",
    expDate: "Geldig tot",
    visitDate: "Datum van uw bezoek",
    submit: "Zoek Kassabon(nen)",
    registerEmail: "Geef uw e-mail om uw kassabonnen te ontvangen",
    registerEmailSuccess: "Email adres succesvol opgeslagen.",
    registerEmailFail:
      "Email adres niet opgeslagen omdat er geen kassabonnen aanwezig zijn met deze betaalkaart en/of datum van bezoek.",
    unrecognizedError: "An unrecognized error occurred",
    inconclusiveCardInfo: "We can not find your receipt",
    optionalFieldPlaceholder: 'Optioneel',
    invalidCaptcha: "Invalid captcha, please try again",
    oasisApiError:
      "We could not connect to the receipts server. Please try again later.",
    orderNotFound: "Bestelling niet gevonden",
  },
  receiptError: {
    notFound: {
      title: "Kassabon niet gevonden",
      message: "We konden geen kassabon voor deze bestelling vinden. Deze kan zijn verlopen, verwijderd of de link is onjuist.",
      retry: "Opnieuw proberen",
      contactSupport: "Contact opnemen met ondersteuning",
      goBack: "Terug",
    },
    serverError: {
      title: "Er is iets misgegaan",
      message: "Dit ligt aan ons. Probeer het over een moment opnieuw. Als het blijft gebeuren, neem dan contact op met ons ondersteuningsteam.",
      retry: "Opnieuw proberen",
      contactSupport: "Contact opnemen met ondersteuning",
    },
  },
  notFound: {
    title: "Pagina niet gevonden",
    message: "Er is iets misgegaan of de link is onjuist.",
    goHome: "Ga naar startpagina",
    goBack: "Terug",
  },
};
